import { useQuery } from "@tanstack/react-query";

import type { NotificationFilter } from "@recobra/schemas/notification";

import { notificationsApi } from "../lib/api";

export const notificationsQueryKey = (filter: NotificationFilter) =>
  ["notifications", filter] as const;

export const useNotifications = (filter: NotificationFilter) =>
  useQuery({
    queryKey: notificationsQueryKey(filter),
    queryFn: () => notificationsApi.list({ filter }),
  });
